import type { EventPayload } from '@side/analytics';

export enum TrackContactSyncEvents {
  MountModal,
  UnmountModal,
  ClickIgnoreButton,
  ClickConnectButton,
}

export enum ContactSyncAccountType {
  Google = 'google',
  FollowUpBoss = 'fub',
}

type EventTypeLabels = Record<TrackContactSyncEvents, string>;

export const ContactSyncEventLabels: EventTypeLabels = {
  [TrackContactSyncEvents.MountModal]: 'CONTACT_SYNC',
  [TrackContactSyncEvents.UnmountModal]: 'CONTACT_SYNC',
  [TrackContactSyncEvents.ClickIgnoreButton]: 'CONTACT_SYNC',
  [TrackContactSyncEvents.ClickConnectButton]: 'CONTACT_SYNC',
};

type EventTypePayloads = Record<TrackContactSyncEvents, EventPayload>;

export const ContactSyncEventsMap: EventTypePayloads = {
  [TrackContactSyncEvents.MountModal]: {
    eventContainer: 'connect_contact_modal',
    eventTarget: 'connect_contact_modal',
    eventType: 'load',
    task: 'view',
  },
  [TrackContactSyncEvents.UnmountModal]: {
    eventContainer: 'connect_contact_modal',
    eventTarget: '', // dynamic
    eventType: 'click',
    task: 'exit',
  },
  [TrackContactSyncEvents.ClickIgnoreButton]: {
    eventContainer: 'contact_dropdown',
    eventTarget: 'ignore_button',
    eventType: 'click',
    task: 'select',
  },
  [TrackContactSyncEvents.ClickConnectButton]: {
    eventContainer: '', // dynamic
    eventTarget: 'connect_button',
    eventType: 'click',
    task: 'select',
  },
};
